import { CalendarTodayOutlined } from "@mui/icons-material";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useAnalyticsData } from "modules/customerTickets/hooks/useAnalyticsData";
import React, { FC } from "react";
import ToolbarItem from "shared/components/DraftEditor/components/ToolbarItem";
import { COLOR_GREY_10 } from "shared/theme/colors";
import { InfoOutlinedIcon } from "shared/theme/icons/InfoOutlinedIcon";
import { formatResponseTime } from "shared/utils/formatResponseTime";
import { StyledSpinnerWrapper } from "../../styled";
import ComparingSection from "./components/ComparingSection";
import {
  StyledContainer,
  StyledGreyText,
  StyledNoDataContainer,
} from "./styled";

const AverageResponseTime: FC = () => {
  const { thisWeekAverageResponseTime, isLoading } = useAnalyticsData();

  return (
    <StyledContainer>
      {!isLoading && (
        <Stack spacing="0.5rem">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="heading6">Average response time</Typography>
            <ToolbarItem
              Icon={<InfoOutlinedIcon />}
              isTooltip
              tooltipTitle={
                <Typography variant="body1">
                  <strong>What it does:</strong> Tracks the average response
                  time between user messages and agent replies, compared to the
                  previous time period.
                  <br />
                  <br />
                  <strong>How it works:</strong> Calculates the average by
                  dividing the total response time for all messages by the
                  number of responses.
                </Typography>
              }
            />
          </Box>
          {Boolean(thisWeekAverageResponseTime) ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="heading1">
                {formatResponseTime(thisWeekAverageResponseTime)}
              </Typography>
              <ComparingSection />
            </Box>
          ) : (
            <StyledNoDataContainer>
              <CalendarTodayOutlined sx={{ color: COLOR_GREY_10 }} />
              <StyledGreyText>No data available yet</StyledGreyText>
            </StyledNoDataContainer>
          )}
        </Stack>
      )}
      {isLoading && (
        <StyledSpinnerWrapper>
          <CircularProgress />
        </StyledSpinnerWrapper>
      )}
    </StyledContainer>
  );
};

export default AverageResponseTime;
